import 'regenerator-runtime/runtime.js';

import Swiper, { Autoplay, EffectFade, Keyboard, Navigation, Pagination, Thumbs } from 'swiper';
Swiper.use([Autoplay, EffectFade, Keyboard, Navigation, Pagination, Thumbs]);

import animations from './utils/animations';
import benefits from './modules/benefits';
import blankLinks from './modules/blankLinks';
import contact from './modules/contact';
import contribution from './modules/contribution';
import error from './modules/error-404';
import features from './modules/features';
import fixVhOnResize from './utils/fixVhOnResize';
import headImage from './modules/head-image';
import header from './modules/header';
import headerMenu from './modules/header-menu';
import hero from './modules/hero';
import inlineVideo from './modules/inline-video';
import imageScroll from './modules/image-scroll';
import link from './modules/link';
import lottie from './modules/lottie';
import mousePointer from './modules/mouse-pointer';
import news from './modules/news';
import newsSlider from './modules/news-slider';
import parallax from './modules/parallax';
import partners from './modules/partners';
import playVideo from './modules/play-video';
import projects from './modules/projects';
import projectsSlider from './modules/projects-slider';
import solutions from './modules/solutions';
import team from './modules/team';
import tippy from './modules/tippy';
import tools from './modules/tools';
import windowWidthResize from './utils/windowWidthResize';

(function ($) {
  const initMethods = [
    animations.init,
    benefits,
    blankLinks,
    contact,
    contribution,
    error,
    features,
    fixVhOnResize,
    headImage,
    header,
    headerMenu,
    hero,
    inlineVideo,
    imageScroll,
    link,
    lottie,
    news,
    newsSlider,
    parallax,
    partners,
    playVideo,
    projects,
    projectsSlider,
    solutions,
    team,
    tippy,
    tools,
    windowWidthResize,
    mousePointer, // keep in the end
  ];

  $(() => {
    requestAnimationFrame(() => {
      for (let i = 0; i < initMethods.length; i += 1) {
        try {
          initMethods[i]($);
        } catch (error) {
          console.error(error);
        }
      }
    });
  });
}(window.jQuery));
